import { useEffect } from "react";
import { useActiveHouse } from "@apps/dashboard/features/houses/active-house-context";

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** Si la ruta incluye `:houseId`, alinea la casa activa del contexto (selector + sidebar). */
export function useSyncHouseFromParams(houseId: string | undefined): void {
  const { setActiveHouseId } = useActiveHouse();

  useEffect(() => {
    if (houseId && UUID_RE.test(houseId)) {
      setActiveHouseId(houseId);
    }
  }, [houseId, setActiveHouseId]);
}
